import { IBaseFormBuilder } from '../../builders/base-builder.class';

export class LegalPersonDataStepDirector {
  constructor(private builder: IBaseFormBuilder) { }

  make() {
    this.builder.build();
  }
}
